export const FEATURES = {
  newsletter: false,
  forum: true,
};

export function isFeatureEnabled(name) {
  return FEATURES[name] === true;
}
